/**
 * @deprecated Use immutable transform directly
 * @todo - Clean up remaining object transform useage and delete this
 *
 * This transform does not allow for attributes to be nullable. It remains only to preserve
 * compatability with endpoints which may expect null or undefined Model attribute values to
 * serialize and deserialize into empty objects.
 */
import ImmutableTransform from 'garaje/transforms/immutable';
import $ from 'jquery';

export default class ObjectTransform extends ImmutableTransform {
  deserialize(value) {
    return super.deserialize($.isPlainObject(value) ? value : {});
  }

  serialize(value) {
    return super.serialize($.isPlainObject(value) ? value : {});
  }
}
